import { useState } from 'react';

const AddDimensionDataPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddDimensionDataPopup, setShowAddDimensionDataPopup] =
      useState<boolean>(false);

    const addDimensionDataToggleHandler = () => {
      setShowAddDimensionDataPopup(!showAddDimensionDataPopup);
    };

    return (
      <Component
        showAddDimensionDataPopup={showAddDimensionDataPopup}
        addDimensionDataToggleHandler={addDimensionDataToggleHandler}
        {...props}
      />
    );
  };

export default AddDimensionDataPopupHOC;
